<template>
    <main class="a-archive a-main" id="a-archive">
        <div class="a-main__container">
            <a href="/analytics/" class="a-main__title a-archive__breadcrumb">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12.0004" r="3" fill="#252628"/>
              </svg> <span>{{ breadcrumb }}</span>
            </a>
            <h2 class="a-main__title a-archive__title">
                {{ title }}
            </h2>
            <div
                v-if="archive"
                class="a-archive__filter">
                <form @submit.prevent="onSubmit">
                    <div class="a-archive__fieldgroup">
                        <div class="a-archive__search-wrap">
                            <input
                                class="a-archive__search"
                                type="text"
                                :name="searchName"
                                placeholder="Введите название"
                                v-model="searchValue"
                                @input="showClearBtn"
                                ref="searchField"
                                autocomplete="off" />
                            <button class="a-archive__search-submit">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8ZM8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C9.84872 16 11.551 15.3729 12.9057 14.3198L16.2929 17.7071L17.7071 16.2928L14.3199 12.9056C15.3729 11.5509 16 9.8487 16 8C16 3.58172 12.4183 0 8 0Z" fill="black"/>
                                </svg>
                            </button>
                            <button
                                v-if="searchValue"
                                class="a-archive__clear"
                                @click.prevent="clearSearchField">
                            </button>
                        </div>
                    </div>
                    <div class="a-archive__fieldgroup">
                        <select-filter-checkbox
                            :filter-data="archive.filters.sections.values"
                            :active-item="activeSectionId"
                            @chosen-filter-items="chosenFilterItems"/>
                    </div>
                    <div class="a-archive__fieldgroup">
                        <datepicker-select
                            class="a-archive__datepick"
                            :is-month-mode="monthMode"
                            :is-range-mode="rangeMode"
                            :presetDate="presetDate"
                            :min-date="minDate"
                            :max-date="maxDate"
                            :clearable="isClearable"
                            @select-date="getNewDate"
                            @reset-date="clearDatepicker" />
                        <svg
                            class="a-archive__date-icon"
                            width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.16732 0V0.833333H0.833984V19.1667H19.1673V0.833333H15.834V0H14.1673V0.833333H5.83398V0H4.16732ZM2.50065 2.5H4.16732V3.33333H5.83398V2.5H14.1673V3.33333H15.834V2.5H17.5006V4.16667H2.50065V2.5ZM2.50065 5.83333H17.5006V17.5H2.50065V5.83333ZM4.16732 10.8333V12.5H5.83398V10.8333H4.16732ZM7.50065 10.8333V12.5H9.16732V10.8333H7.50065ZM10.834 10.8333V12.5H12.5007V10.8333H10.834ZM14.1673 10.8333V12.5H15.834V10.8333H14.1673ZM4.16732 14.1667V15.8333H5.83398V14.1667H4.16732ZM7.50065 14.1667V15.8333H9.16732V14.1667H7.50065ZM10.834 14.1667V15.8333H12.5007V14.1667H10.834Z" fill="black"/>
                        </svg>
                    </div>
                </form>
            </div>
            <div class="a-archive__component">
                <loader v-if="isLoading" />
                <div v-if="archive"
                    class="a-archive__wrapper">
                  <div class="a-archive__wrapper-container">
                    <p class="a-archive__sub">
                      {{ formatItemsCount }}
                    </p>
                  </div>
                    <archive-item :archive-items-data="archive"/>
                </div>
                <error v-if="error" />
            </div>
        </div>
    </main>
</template>

<script>
    import Loader from '../Loader'
    import Error from '../Error'
    import ArchiveItem from './components/ArchiveItem'
    import DatepickerSelect from '../../vue-components/DatepickerSelect'
    import SelectFilterCheckbox from '../helpers/SelectFilterCheckbox'
    import {archiveActionTypes} from '../../store/modules/archive'
    import {mapState} from 'vuex'

    import headerSearchHandler from '../../modules/a-main-nav'
    import declineWordOfNum from '../../modules/decline-word-of-num'

    export default {
        name: 'Archive',
        components: {
            ArchiveItem,
            Loader,
            Error,
            DatepickerSelect,
            SelectFilterCheckbox
        },
        data() {
            return {
            title: 'Все отчёты',
                breadcrumb: 'Аналитика',
            subtitle: 'Все отчёты',
                apiUrl: '/api/v2/content/analytics/archive/',
                count: '',
                searchName: 'search',
                searchValue: '',
                dateStart: '',
                dateEnd: '',
                filterValue: [],
                clearButton: false,
                totalParams: '',
                searchParams: '',
                dateParams: '',
                filterParams: '',
                rangeMode: true,
                monthMode: false,
                presetDate: null,
                minDate: null,
                maxDate: null,
                isClearable: false,
                activeSectionId: '',
            }
        },
        computed: {
            ...mapState({
                isLoading: state => state.archive.isLoading,
                archive: state => state.archive.data,
                error: state => state.archive.error
            }),
            formatItemsCount () {
                return `Найдено: ${this.archive.total} ${declineWordOfNum(this.archive.total, ['отчёт', 'отчёта', 'отчётов'])}`
            },
            mobileDevice () {
                return typeof window === 'object' && window.innerWidth < 768
            },
            tabletDevice () {
                return typeof window === 'object' && window.innerWidth >= 768 && window.innerWidth < 1025
            },
            desktopSmallDevice () {
                return typeof window === 'object' && window.innerWidth >= 1025 && window.innerWidth < 1200
            },
            desktopDevice () {
                return typeof window === 'object' && window.innerWidth >= 1200
            },
        },
        methods: {
            showClearBtn () {
                this.searchValue.length > 0 ?
                this.clearButton = true :
                this.clearButton = false
            },

            clearSearchField () {
                this.searchValue = ''
                this.$refs.searchField.focus()
                this.clearButton = false
                this.onSubmit()
            },

            clearDatepicker () {
                this.isClearable = false
                this.dateStart = ''
                this.dateEnd = ''
                this.onSubmit()
            },

            getNewDate (newDate) {
                this.isClearable = true
                this.dateStart = `${newDate[0].getDate()}.${newDate[0].getMonth() + 1}.${newDate[0].getFullYear()}`
                this.dateEnd = `${newDate[1]?.getDate()}.${newDate[1]?.getMonth() + 1}.${newDate[1]?.getFullYear()}`
                this.onSubmit()
            },

            getCurrentDate () {
                this.maxDate = new Date()
            },

            chosenFilterItems (filterActiveFields) {
                this.filterValue = filterActiveFields
                this.onSubmit()
            },

            onSubmit () {
                let totalParamsArr = [];

                if (this.searchValue) {
                    this.searchParams = `${this.searchName}=${this.searchValue}`
                    totalParamsArr.push(this.searchParams)
                }

                if (this.filterValue && this.filterValue.length !== 0) {
                    this.filterParams = `section=${this.filterValue.join(',')}`
                    totalParamsArr.push(this.filterParams)
                }

                if (this.dateStart) {
                    this.dateParams = `date-from=${this.dateStart}&date-to=${this.dateEnd}`
                    totalParamsArr.push(this.dateParams)
                }
                this.totalParams = `?${totalParamsArr.join('&')}`

                this.$store.dispatch(archiveActionTypes.getArchive, {apiUrl: this.apiUrl, archiveFilter: this.totalParams})
                history.pushState(null, null, `${window.location.href.split('?')[0]}${this.totalParams}`);
            },
        },
        mounted() {
            if (window.location.search) {
                this.totalParams = window.location.search
            }
            // this.activeSectionId = this.totalParams.split('=')[1]
            const params = new URLSearchParams(this.totalParams);
            let arr = [];
            for (const [key, value] of params) {
                arr.push({key, value});
            }
            arr.forEach((el)=> {
                if (el.key === 'search') {
                    this.searchValue = el.value
                }
                if (el.key === 'section') {
                    this.activeSectionId = el.value
                    this.filterValue = [el.value]
                }
            })
            this.$store.dispatch(archiveActionTypes.getArchive, {apiUrl: this.apiUrl, archiveFilter: this.totalParams})
            headerSearchHandler()
            this.getCurrentDate()
        }
    }
</script>